import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import { Autocomplete, Box, Button, TextField, Tooltip } from '@mui/material';
import React, { useState } from 'react';
import languages from '../../helpers/utils/languages';

export const TemplateSelect = ({ onChange, templates = [] }) => {
  const [checkedItem, setCheckedItem] = useState({
    name: 'Sans Template',
  });
  // const options = [{ _id: 'None', name: 'Sans Template' }, ...templates];

  const handleChange = (value) => {
    const newValue = value?._id?.toString() || 'None';
    setCheckedItem(value);
    onChange(newValue);
  };

  const onClear = () => {
    setCheckedItem({ _id: 'None', name: 'Sans Template' });
    onChange('None');
  };
  return (
    <Box sx={{ display: 'flex', padding: 0 }}>
      <Autocomplete
        sx={{ width: '100%' }}
        size="small"
        allowClear={false}
        options={templates}
        value={checkedItem}
        getOptionLabel={(option) => (option?.name ? option?.name : '')}
        getOptionDisabled={(option) => option?.isDraft}
        onChange={(event, value) => {
          handleChange(value);
        }}
        renderValue={(value) => value?.name}
        renderInput={(params) => <TextField {...params} label={'Templates'} />}
        renderOption={(props, option) => {
          const optionLang = languages?.find(
            ({ code2 }) => code2 === option?.language
          );
          const { key, ...optionProps } = props;
          return (
            <li key={key} {...optionProps}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <span className={`fi fi-${optionLang?.flag}`} />
                {option?.name}
              </Box>
            </li>
          );
        }}
      />
      <Tooltip title="Effacer le texte">
        <Button
          variant="outlined"
          size="small"
          onClick={onClear}
          sx={{ ml: 1 }}
        >
          <AutoFixHighIcon />
        </Button>
      </Tooltip>
    </Box>
  );
};
